<template>
  <div>
    <v-container class="pl-10 pr-10 ml-0">
      <AdditionalService ref="AdditionalService"></AdditionalService>
    </v-container>
  </div>
</template>

<script>
import AdditionalService from "@/components/mileage/additional_service/AdditionalService.vue";
export default {
  components: {
    AdditionalService,
  },
};
</script>
